import React, { useState } from 'react';
import { AGE_BANDS } from '../../../utils/childChapterUtils';
import BandTransitionMapping from './BandTransitionMapping';

/**
 * Notice shown after an age-band transition.
 * Displays story carry-over count and an expandable chapter mapping.
 *
 * Props:
 *   transition - { fromBand, toBand, storiesCarried, seenByGuardian }
 *   onDismiss  - callback to acknowledge the transition
 */
function BandTransitionNotice({ transition, onDismiss }) {
  const [showMapping, setShowMapping] = useState(false);

  if (!transition) return null;

  const fromLabel = AGE_BANDS[transition.fromBand]?.label || transition.fromBand;
  const toLabel = AGE_BANDS[transition.toBand]?.label || transition.toBand;
  const storiesCarried = transition.storiesCarried || 0;

  return (
    <div className="rounded-xl border-2 border-[#E65100]/40 bg-[#FFF3ED] p-5 sm:p-6 mb-6">
      <div className="flex items-start gap-3">
        <span className="text-2xl flex-shrink-0" role="img" aria-label="growing">
          {'\uD83C\uDF1F'}
        </span>
        <div className="flex-1">
          <h3 className="font-serif text-lg sm:text-xl font-bold text-[#E65100] mb-1">
            New chapters unlocked!
          </h3>
          <p className="text-gray-700 text-base leading-relaxed">
            Your child has grown from <strong>{fromLabel}</strong> to <strong>{toLabel}</strong>.
            {storiesCarried > 0 && (
              <> All <strong>{storiesCarried}</strong> {storiesCarried === 1 ? 'story has' : 'stories have'} been carried forward into the new chapters.</>
            )}
          </p>

          <button
            onClick={() => setShowMapping(!showMapping)}
            className="mt-3 text-sm text-[#E65100] hover:text-[#BF360C] underline underline-offset-2 transition-colors"
          >
            {showMapping ? 'Hide chapter mapping' : 'See chapter mapping'}
          </button>

          {showMapping && (
            <BandTransitionMapping
              fromBand={transition.fromBand}
              toBand={transition.toBand}
            />
          )}

          <div className="mt-4">
            <button
              onClick={onDismiss}
              className="px-5 py-2 rounded-lg bg-[#E65100] text-white font-medium text-base hover:bg-[#BF360C] transition-colors"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BandTransitionNotice;
